import React, {useState,useContext,useEffect} from 'react';
import './css/contest.scss';
import QuestionAnswers from '../Components/Quiz/QuestionAnswers';
import ResponseSummary from '../Components/Quiz/ResponseSummary';
import Results from '../Components/Quiz/Results';
import ProgressBar from '../Components/ProgressBar/ProgressBar';
import Validation from '../Components/Quiz/Validation';
import { ConfigurationContext } from '../Context/Configuration';
import { RedButton } from '../Components/Buttons/Buttons';
import { Redirect } from 'react-router';

const QA=()=>{
	
	const [question,setQuestion] = useState(0);
	const [progress,setProgress] = useState(10);
	const [buttonStatus,setButtonStatus] = useState("Confirm");
	const [displayValidation,setDisplayValidation] = useState("none");
	const [validationMsg,setValidationMsg] = useState("");
	const [isCorrect,setCorrect] = useState(false);
	const [showQuestions,setShowQuestions] = useState(true);
	const [showSummary,setShowSummary] = useState(false);
	const [showResult,setShowResult] = useState(false);
	const [config,update] = useContext(ConfigurationContext);
	
	const confirmAnswer = () => {
		if(buttonStatus==="Confirm")
		{ 
			if(Object.keys(config.questions[question]["selectedAnswer"]).length>0)
			{
			setButtonStatus("Next")
			update({...config, disableOptions:true})
			setDisplayValidation("block");
			if(config.questions[question]["selectedAnswer"]["isCorrect"])
				{
					setCorrect(true)
					setValidationMsg(config.questions[question]["correctValidation"])
				}
			else 
				{
					setCorrect(false)
					setValidationMsg(config.questions[question]["incorrectValidation"])
				}
			}
		}
		else
		{
			update({...config, disableOptions:false})
			setButtonStatus("Confirm");
			setDisplayValidation("none");
			var currentQuestion = question+1;
			if(currentQuestion > config.questions.length-1)
			{
				setShowQuestions(false);
				setShowSummary(true);
			}
			else{
				setProgress((question+1)/5*100);
				setQuestion(currentQuestion);
			}
		}
	}
	const checkResults = () => {
		
		if(config.questions.filter(a => a["selectedAnswer"]["isCorrect"]).length < 4)
		{
			
			update({...config, restartQuiz:true})
		}
		else {
			setShowSummary(false)
			setShowResult(true)
		}
	}

	return(
		config.questions.length == 0 ? <Redirect to='/entercontest'/> :
		<React.Fragment>
			<div style={{display:showQuestions?"block":"none"}} className="questions_container">
				<ProgressBar bgcolor={"#c61a21"} completed={progress}></ProgressBar>
				 <br/>
				 <p style={{fontWeight:'bold'}}>Feel the Burn Contest.</p>
				<QuestionAnswers questionNumber={question} question={config.questions[question]}></QuestionAnswers>
				<Validation display={displayValidation} isCorrect={isCorrect} validationMsg={validationMsg}/>
				<RedButton style={{marginLeft:'auto',display:'block'}} label={buttonStatus} onClick={confirmAnswer}/>
			</div>
			<div className="response_summary" style={{display:showSummary?"block":"none"}}>
				<ResponseSummary />
				<RedButton label={'Next'} onClick={checkResults}/>
			
			</div>
			<div className="result" style={{display:showResult?"block":"none"}}>
				<Results/>
			</div>
			
		</React.Fragment>
	);
}

export default QA;

